/**
 * Created by Ning Jiang on 11/12/2018.
 */

import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IBetWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IdleAnimationController} from "@nolimitcity/slot-game/bin/game/idleanimation/IdleAnimationController";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TweenLite} from "gsap";
import {TombstoneGameConfig} from "../TombstoneGameConfig";

interface ITumbleWeedAnimationConfig {
    layer:ScalableLayer,
    scale:number,
    startPosition:[number, number],
    endPosition:[number, number]
}

export class TumbleWeedIdleAnimation extends IdleAnimationController {

    private _betWinsData:IBetWinData[] | null;

    private _configs:ITumbleWeedAnimationConfig[] = [
        {
            layer : StageManager.getLayer(TombstoneGameConfig.instance.LAYERS.IDLE_FOREGROUND.name),
            scale : 1,
            startPosition : [1300, 608],
            endPosition : [-20, 620]
        },
        {
            layer : StageManager.getLayer(TombstoneGameConfig.instance.LAYERS.IDLE_BACKGROUND.name),
            scale : 0.5,
            startPosition : [1450, 432],
            endPosition : [790, 432]
        },
        {
            layer : StageManager.getLayer(TombstoneGameConfig.instance.LAYERS.IDLE_BACKGROUND.name),
            scale : 0.5,
            startPosition : [510, 452],
            endPosition : [-150, 452]
        }
    ];

    constructor() {
        super({
            startTime : 3,
            minInterval : 0.5,
            maxInterval : 20
        });
    }

    protected onGameDataParsed(data:ParsedGameData):void {
        this._betWinsData = data.betWins;
    }

    protected hasWin():boolean {
        return this._betWinsData != null && this._betWinsData.length > 0;
    }

    protected playIdleAnimation():void {
        const config:ITumbleWeedAnimationConfig = this._configs[StageManager.orientation === Orientation.PORTRAIT ? 0 : Math.round(Math.random()) + 1];
        const animation:TimelineSprite = new TimelineSprite(GameResources.getTextures("tumbleWeed"));
        animation.scale.set(config.scale);
        animation.getAnimation();
        TweenLite.fromTo(animation, Math.random() * 0.5 + 1.5,
            {x : config.startPosition[0], y : config.startPosition[1]},
            {
                x : config.endPosition[0], y : config.endPosition[1], onComplete : () => {
                    config.layer.removeChild(animation);
                    animation.destroy();
                }
            });
        config.layer.addChild(animation);
    }
}